import { PropsWithChildren } from 'react';
import { useAppBarHeight } from '../useAppBarHeight';

type WrapperWithAppBarHeightProps = PropsWithChildren<{
  className?: string;
}>;

export function WrapperWithAppBarHeight({ children, className }: WrapperWithAppBarHeightProps) {
  const { heightWithoutAppBar } = useAppBarHeight();

  return (
    <div className={className} style={{ height: heightWithoutAppBar }}>
      {children}
    </div>
  );
}
